import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/entities/Station';

export class Abschnitt {
  constructor({
    id,
    name,
    stationen,
  }: {
    id: string;
    name: string;
    stationen: ArbeitsbereichStation[];
  }) {
    this.id = id;
    this.name = name;
    this.stationen = stationen;
  }

  id: string;
  name: string;
  stationen: ArbeitsbereichStation[];
}
